import { createTheme } from "@mui/material/styles";
const theme = createTheme({
  shape: {
    borderRadius: 6,
  },
  palette: {
    primary: {
      main: "#FF8C00", // ส้มสด
      contrastText: "#fff",
    },
    secondary: {
      main: "#FFD700", // เหลืองทอง
      contrastText: "#fff",
    },
    error: {
      main: "#FF4500", // แดงส้ม
      contrastText: "#fff",
    },
    success: {
      main: "#32CD32", // เขียวสด
      contrastText: "#fff",
    },
    warning: {
      main: "#FFA500", // ส้มอ่อน
      contrastText: "#fff",
    },
  },
  typography: {
    fontFamily: ["Noto Sans Thai", "sans-serif"].join(","),
  },
});
export default theme;
